export default "__VITE_PUBLIC_ASSET__57ce6794__"